import { useDeleteUserMutation } from "../api";

import { DeleteConfirm } from "@/components/ui/v2/delete-confirm";

export const DeleteUserConfirm = ({
  id,
  name,
  open,
  onOpenChange,
}: {
  id: string;
  name: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => {
  const deleteUserMutation = useDeleteUserMutation();

  const handleDelete = () => {
    deleteUserMutation.mutate(
      { id },
      {
        onSuccess: () => {
          onOpenChange(false);
        },
      }
    );
  };

  return (
    <DeleteConfirm
      open={open}
      onOpenChange={onOpenChange}
      onDelete={handleDelete}
      isLoading={deleteUserMutation.isPending}
      name={name}
      entityType="user"
    />
  );
};
